import { Link } from "react-router-dom";
import styles from "../../components/DashBoard/Header.module.css";
import { useSelector } from "react-redux";

const Error = ({ Message = "seems like you are lost", subMessage = "The page you're looking for is not here." }) => {
  const User = useSelector(state => state.User)
  return (
    <>
      <header className={styles.headerStyle}>
        <Link to={User?.user_name ? "/dashboard" : '/login'} className={styles.hEADERTITLE}>
          <div className={styles.authnumberLogo}>
            <div className={styles.authnumberParent}>
              {/* <p className={styles.authnumberIcon}>AuthNumber</p> */}
              <img
                className={styles.authnumberIcon}
                loading="eager"
                alt=""
                src="/authnumber_1.svg"
              />
              <img
                className={styles.subtractIcon}
                loading="eager"
                alt=""
                src="/Header_icon.svg"
              />
            </div>
          </div>
        </Link>
      </header>
      <div className={styles.mainContainer}>
        <div className={styles.errorContainer}>
          <h1 className={styles.h1}> {Message} </h1>
          <p className={styles.p}>
            {subMessage}
          </p>
          <div className={styles.btn}>
            <Link to={User?.user_name ? "/dashboard" : '/login'} className={styles.Link}> Go Back to Home </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Error;
